import { api } from './client'
import type { ScoreOut } from '@/types'

export const gameApi = {
  leaderboard: () => api.get<ScoreOut[]>('/game/leaderboard'),
  submitScore: (score: number, nickname?: string) =>
    api.post<ScoreOut>('/game/score', { score, nickname: nickname || null }),
}
